import { all, takeLatest, call, put } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import { getSiteAppsSuccess, getSiteAppsFailure } from './actions';
import { SiteActionTypes } from './types';
import {
  getSiteApplications,
  verifyAppAuthorization
} from 'services/site-app.service';

function* handleGetSiteApps() {
  try {
    const response: AxiosResponse = yield getSiteApplications();
    if (Array.isArray(response.data)) {
      const apps: any[] = yield Promise.all(
        response.data
          .filter(
            (app) =>
              app.client_id !==
                process.env.REACT_APP_IDENTITY_LOCATE_CLIENTID &&
              app.client_id !== 'SWXHelp'
          )
          .map(async (app) => {
            const allowedHttpStatusCode = [200, 401, 403];
            const verifiedResponse: AxiosResponse =
              await verifyAppAuthorization(app.client_id);
            return {
              ...app,
              authorized: !!verifiedResponse.data?.success,
              isAppDown: !allowedHttpStatusCode.includes(
                verifiedResponse.data?.code
              )
            };
          })
      );
      yield put(getSiteAppsSuccess(apps));
    } else {
      yield put(getSiteAppsFailure('Unable to get site applications'));
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(getSiteAppsFailure(errMsg || 'Unable to get site applications'));
  }
}

function* watchGetSiteApps() {
  yield takeLatest(SiteActionTypes.GET_SITE_APPS_START, handleGetSiteApps);
}

function* siteSagas() {
  yield all([call(watchGetSiteApps)]);
}

export default siteSagas;
